import axios from 'axios'
const local = process.env.REACT_APP_SERVER_URL;

// Safari detection utility
const isSafari = () => {
    const userAgent = navigator.userAgent;
    return /Safari/.test(userAgent) && !/Chrome/.test(userAgent);
};

const api = axios.create({
    baseURL: `${local}/api`,
    withCredentials : true
})

// Request interceptor to add Authorization header for Safari
api.interceptors.request.use(
    (config) => {
        // For Safari, add Authorization header if we have a stored token
        if (isSafari()) {
            const authToken = localStorage.getItem('authToken');
            const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
            
            // Only add the token if we're supposed to be logged in and have a valid token
            if (authToken && isLoggedIn) {
                try {
                    // Basic validation - check if token looks valid (not expired on client side)
                    const tokenParts = authToken.split('.');
                    if (tokenParts.length === 3) {
                        config.headers.Authorization = `Bearer ${authToken}`;
                    }
                } catch (error) {
                    // If token is malformed, remove it
                    console.log('Invalid Safari auth token, removing...');
                    localStorage.removeItem('authToken');
                    localStorage.removeItem('isSafariAuth');
                }
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle token refresh
api.interceptors.response.use(
    (response) => {
        // If it's a logout response with Safari flag, clear localStorage
        if (response.data?.isSafari && response.data?.clearLocalStorage) {
            localStorage.removeItem('authToken');
            localStorage.removeItem('isSafariAuth');
            localStorage.removeItem('isLoggedIn');
            localStorage.removeItem('userRole');
        }
        return response;
    },
    async (error) => {
        const originalRequest = error.config;
        
        if (error.response?.status === 409 && 
            (error.response?.data?.code === 'TOKEN_EXPIRED' || 
             error.response?.data?.code === 'INVALID_TOKEN') &&
            !originalRequest._retry) {
            
            originalRequest._retry = true;
            
            try {
                // Try to refresh the token
                console.log('Attempting token refresh...');
                await api.post('/refresh-token');
                console.log('Token refreshed successfully, retrying original request');
                // Retry the original request
                return api(originalRequest);
            } catch (refreshError) {
                // If refresh fails, redirect to login
                console.log('Token refresh failed, redirecting to login');
                localStorage.removeItem('isLoggedIn');
                localStorage.removeItem('userRole');
                localStorage.removeItem('authToken');
                localStorage.removeItem('isSafariAuth');
                
                // Only redirect if we're not already on the login page
                if (!window.location.pathname.includes('/login')) {
                    window.location.href = '/login';
                }
                return Promise.reject(refreshError);
            }
        }
        
        // If it's an auth error and we can't refresh, redirect to login
        if (error.response?.status === 409 && error.response?.data?.code === 'NO_TOKEN') {
            console.log('No token found, redirecting to login');
            localStorage.removeItem('isLoggedIn');
            localStorage.removeItem('userRole');
            localStorage.removeItem('authToken');
            localStorage.removeItem('isSafariAuth');
            
            // Only redirect if we're not already on the login page
            if (!window.location.pathname.includes('/login')) {
                window.location.href = '/login';
            }
        }
        
        return Promise.reject(error);
    }
);

export default api